<img
  class="z-0 object-cover object-center"
  [ngSrc]="url()"
  [alt]="alt()"
  [priority]="priority()"
  fill />
